import axios from "../../axios.js";

const endpoints = {
    registration: '/register',
    authentication: '/login',
    validateUser: '/account/details',
    logout: '/account/logout'
}

const tokenName = '_thrubits_token'

const state = {
    name: '',
    email: '',
    phone: '',
    token: ''
}
const actions = {
    validateUser: ({ commit }) => {
        return new Promise((resolve, reject)=>{        
            axios.get(endpoints.validateUser, {'headers': { 'Authorization': 'Bearer '+ localStorage.getItem(tokenName) }})
            .then(resp => {        
                if(resp.status === 200){
                    commit('setUserData', resp.data.thrubit_auth_user.user);
                    resolve(resp);
                }
            })
            .catch(err => {
                commit('authError', err);
                reject(err);
            });
        })
    },
    registration: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(endpoints.registration, payload)
            .then(resp => {
                if(resp.status === 200) {
                    resolve(resp);
                    commit('authSuccess', resp.data);
                    commit('setUserData', resp.data.thrubit_auth_user);
                }
                else
                    reject(resp);            
            })
            .catch(err => {
                reject(err);
            });
            
        });
    },
    authentication: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(endpoints.authentication, payload)
            .then(resp => {
            if(resp.status === 200) {
                commit('authSuccess', resp.data);
                commit('setUserData', resp.data.thrubit_auth_user);
                resolve(resp);
            }
            else
                reject(resp);            
            })
            .catch(err => {
                commit('authError', err);
                reject(err);
            });
            
        });
    },
    logout: ({ commit }) => {
        return new Promise((resolve, reject) => {
            axios.post(endpoints.logout, {'headers': { 'Authorization': 'Bearer '+ localStorage.getItem("_token") }})
            .then(resp=>{
                if(resp.status === 200) { 
                    commit('authLogout');
                    resolve();
                }
                else
                    reject(resp); 
            })
            .catch(err => {
                commit('authError', err);
                reject(err);
            });
        });
    }
};

const mutations = {
    setUserData: (state, res) => {
        state.name = res.name
        state.email = res.email
        state.phone = res.phone
    },
   
    authSuccess: (state, res) => {
        state.token = res.token;      
        localStorage.setItem(tokenName, res.token);        
        //axios.defaults.headers.common['Authorization'] = 'Bearer '+resp._token
    },
    authError: state => {
        state.token = "";
        localStorage.removeItem(tokenName);
    },
    authLogout: state => {
        state.token = "";
        localStorage.removeItem(tokenName);
        //delete axios.defaults.headers.common['Authorization'];
    },
    // setTokenExpiry: (state, payload) =>{
    //     state.tokenExp = payload
    // }
};
const getters = {
    
};
export default {
    state,
    getters,
    actions,
    mutations
};